module.exports = new __parcel__URL__("shared-folder.0c3dee65.svg").toString();